module.exports = __webpack_public_path__ + "img/fallback.7edf2ebe.png";